// refers to https://github.com/iamkun/dayjs/blob/dev/src/plugin/localizedFormat/index.js

import { PluginFunc } from 'dayjs';

import { localeConfig as enLocaleConfig } from '../config/en';
import { FormatType, FormatTypeConfig } from '../type';

export const englishFormats = enLocaleConfig.formats;

// copy from the official plugin (https://github.com/iamkun/dayjs/blob/dev/src/plugin/localizedFormat/index.js)
// TikTok custom type 'LL-Y' is conficted with normal format which would be treated as LL(double L type) and Y(year)
const u = (formatStr: string, formats: FormatTypeConfig): string =>
  formatStr.replace(
    /(\[[^\]]+])|(LTS?|lts?|L{2,4}\-Y|l{1,4}\-Y|LL\-D|l{1,4}|L{1,4})/g,
    (_, a, b: FormatType) => a || formats[b] || englishFormats[b],
  );

const FORMAT_DEFAULT = 'YYYY-MM-DDTHH:mm:ssZ';

const plugin: PluginFunc = (_o, c, d) => {
  const proto = c.prototype;
  const oldFormat = proto.format;

  d.Ls.en.formats = englishFormats;
  proto.format = function (formatStr = FORMAT_DEFAULT): string {
    const { formats } = this.$locale();
    const result = u(formatStr, formats);
    return oldFormat.call(this, result);
  };
};
export default plugin;
